import { useEffect, useState } from "react";
import { replaceUrl } from "@/lib/replaceUrl";
import type { ProductKind } from "./stockHealth";

// URL value per tab; For sale is the default and has none.
const PARAM: Record<ProductKind, string | null> = {
  for_sale: null,
  gift: "gifts",
  not_moving: "not-moving",
};

function kindFromUrl(): ProductKind {
  if (typeof window === "undefined") return "for_sale";
  const param = new URLSearchParams(window.location.search).get("tab");
  const match = (Object.keys(PARAM) as ProductKind[]).find((kind) => PARAM[kind] === param);
  return match ?? "for_sale";
}

// Mirrors useState<ProductKind> for the Inventory Overview tab, keeping it
// in the URL (?tab=gifts, ?tab=not-moving) so a copied link opens the same tab.
// Replaces the history entry, so Back leaves the page rather than stepping
// through tabs. A missing or unknown value opens For sale.
export function useProductKindParam(): [ProductKind, (next: ProductKind) => void] {
  const [kind, setKind] = useState<ProductKind>(kindFromUrl);

  useEffect(() => {
    const url = new URL(window.location.href);
    const param = PARAM[kind];
    if (param === null) {
      url.searchParams.delete("tab");
    } else {
      url.searchParams.set("tab", param);
    }
    replaceUrl(url);
  }, [kind]);

  return [kind, setKind];
}
